export const getParsedNumericValue = (value: string | number): number | undefined => {
  const parsedValue = Number(`${value}`.replace(/[^0-9.-]+/g, ''));
  return parsedValue === 0 ? undefined : parsedValue;
};
